import { EventBus } from "@/event-bus";
import { ModalIntegrationPopUp } from "@/interfaces/notification";
import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./IntegrationPopUpModal.template.vue";

@Component({
  mixins: [Template]
})
export default class IntegrationPopUpModalComponent extends Vue {
  @Prop({ required: true })
  public connectionModalData!: ModalIntegrationPopUp;

  public accept() {
    if (
      this.connectionModalData.message ===
      "traceability.state_traceability_integration.credential_requirements.message"
    ) {
      EventBus.$emit("acceptHandler");
      this.$router.push({
        name: "profile-management",
        params: { data: JSON.stringify(window.location.href) }
      });
    } else {
      this.$emit("resolve", true);
    }
  }
  public cancel() {
    this.$emit("resolve", true);
  }
}
